import styled from 'styled-components'
import { useQuery } from 'react-query'
import { useContext } from 'react'

import { api } from '@h2/api'
import { SDB } from '@h2/components/colors'
import { Skeleton } from '@h2/components/loading/skeleton'
import { features } from '@h2/components/media'
import { Globals } from '@h2/globals'

import { LegacyContinue } from './legacyContinue'

import { Stats } from '../stats'

const Wrap = styled.div`
  display: flex;
  border: ${SDB} solid 4px;
  border-radius: 10px;
  background-color: ${SDB};
  margin-bottom: 20px;
  justify-content: space-between;
  flex-direction: column;

  @media (${features.minWidth.widescreen}) {
    flex-direction: row;
  }
`
const LegacyGame = () => {
  const { userProfile } = useContext(Globals)
  const { data: gameData, isFetching } = useQuery(['game-listing', userProfile], () =>
    api.fetch('/early/utl', {})
  )

  if (isFetching) {
    return <Skeleton display="block" height="200px" />
  }

  const mostRecentGame = gameData.games[0]

  return (
    <Wrap>
      {mostRecentGame && <Stats game={mostRecentGame} />}
      <LegacyContinue gameId={mostRecentGame?.id} />
    </Wrap>
  )
}

export { LegacyGame }
